import React from 'react';
import Chip from '@material-ui/core/Chip';
import Lock from '@material-ui/icons/Lock';
import {
   MobileNumberDetails,
   MAX_VERIFICATION_ATTEMPTS,
   formatCountdown,
} from './types';

export const LockedStatusChip = () => (
   <Chip
      className="verification-status-chip verification-status-chip-locked"
      icon={<Lock className="verification-status-chip-icon" />}
      label="Locked"
   />
);

interface MobileNumberLockedProps {
   mobileNumberDetails: MobileNumberDetails;
   lockoutSeconds: number;
}

const MobileNumberLocked = ({
   mobileNumberDetails,
   lockoutSeconds,
}: MobileNumberLockedProps) => (
   <div className="mobile-number-text-field">
      <div className="mobile-number-text-field-header">
         <span className="grey2-text input-header">
            Contact Mobile Number <span className="text-red">*</span>
         </span>
         <LockedStatusChip />
      </div>

      <div className="mobile-number-locked">
         <span className="mobile-number-locked-message">
            All {MAX_VERIFICATION_ATTEMPTS} verification attempts for{' '}
            {mobileNumberDetails.mobileNumber} have been used.
         </span>

         <div className="mobile-number-locked-countdown">
            <span className="mobile-number-locked-countdown-label">
               You can try again in
            </span>
            <span className="mobile-number-locked-countdown-value">
               {formatCountdown(lockoutSeconds)}
            </span>
         </div>
      </div>
   </div>
);

export default MobileNumberLocked;
